/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2021-06-03 11:05:27
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-06-16 17:08:25
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\chaining\api\scheme.js
 */
import request from '@/utils/req.js';
//第一个图
export function chart1(params) {
    return request.get("/admin/scheme/chart1", params);
}
//删除项目链
export function delete_Scheme(params,a) {
    return request.delete(`/admin/scheme-item/delete?id=${params}&schemeType=${a}`);
}
//第二个图
export function chart2(params) {
    return request.get("/admin/scheme/chart2", params);
}
//调用模板链
export function call(params) {
    return request.post("/admin/scheme/call", params);
}

// 逻辑设置-获取系统检验库内对应检验项目
export function getInspectionInfoList(params) {
    return request.post("/admin/inspection-info/list", params);
}

// 保存逻辑 
export function schemeLogicSave(params) {
    return request.post("/admin/scheme-logic-group/save", params);
}

// 已保存逻辑数据 
export function getLogicList(params) {
    return request.get("/admin/scheme-logic-group/getListBySchemeId", params);
}

//宣教列表分页查询
export function api_get_mission(params) {
    return request.post("/admin/mission/page",params);
}

//方案关联项目批量删除(清空链)
export function deleteBatchItems(params) {
  return request.post("/dsicm-api/feign/scheme-item/deleteBatchItems",params);
}